import { css } from 'styled-components';

interface BoxProps {
  opened: boolean;
  onClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

const InputDatepickerBox = css <BoxProps>`
  border: 1px solid #ACC2D3;
  text-transform: capitalize;
  border-radius: 40px;
  height: 40px;
  background-color: #fff;
  ${({ opened }) => `
      ${opened && `border: 1px solid #5DC5EA;`}
  `}
`;

export default InputDatepickerBox;
